module.exports = __webpack_public_path__ + "static/media/02-textpage1.df110287.png";